/**
 * Picks the first list that actually has entries.
 *
 * A consent's runtime fields — signer roles, requested signatures, requested data — are
 * written either onto the assignment shell (classic templates) or onto the published
 * Studio template (Studio-published consents), and the side that does not own them still
 * comes back as an empty list rather than as absent. Choosing on presence alone would
 * therefore pick the empty list and silently hide every entry, so the choice is made on
 * content.
 */
export const preferNonEmpty = (primary, fallback) => (primary?.length ? primary : fallback) ?? [];
